<template>
  <div>
    <t-form labelWidth="100px">
      <t-form-item label="添加模型">
        <t-button @click="showGallery">选择模型</t-button>
      </t-form-item>
      <t-form-item label="背景颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.bgColor" size="small"/>
      </t-form-item>
      <t-form-item label="背景透明度">
        <t-input-number v-model="attribute.bgAlpha" :step="0.1" :min="0" :max="1" size="small"/>
      </t-form-item>
      <t-form-item label="环境光颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.ambientLightColor" size="small"/>
      </t-form-item>
      <t-form-item label="点光颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.pointLightColor" size="small"/>
      </t-form-item>
      <t-form-item label="点光X">
        <t-input-number v-model="attribute.pointLightX" :step="0.1" :min="-1024" :max="1024" size="small"/>
      </t-form-item>
      <t-form-item label="点光Y">
        <t-input-number v-model="attribute.pointLightY" :step="0.1" :min="-1024" :max="1024" size="small"/>
      </t-form-item>
      <t-form-item label="点光Z">
        <t-input-number v-model="attribute.pointLightZ" :step="0.1" :min="-1024" :max="1024" size="small"/>
      </t-form-item>
    </t-form>
    <ThreeModels ref="threeModels" @confirmCheck="confirmCheck"/>
  </div>

</template>

<script>
import ThreeModels from "@/components/designer/three-models";
import {fileUrl} from "/env"
export default {
  name: "cpt-threejs-dom-option",
  components: {ThreeModels},
  props: {
    attribute: Object
  },
  data(){
    return {
      fileUrl,
    }
  },
  methods:{
    showGallery(){
      this.$refs.threeModels.opened();
    },
    confirmCheck(fileUrl){
      this.attribute.modeUrl = fileUrl
    }
  }
}
</script>

<style scoped>

</style>
